import React, { useEffect, useState } from 'react';
import { useLoginContext } from '../../Contexts/LoginContext';
import ButtonPrimary from '../Form/ButtonPrimary';
import { TbMoodHappy, TbMoodPuzzled } from "react-icons/tb";
import { formatCartId } from '../../Utils/Formatters';
import { useCartContext } from '../../Contexts/CartContext';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import StepsStoreCounter from './StepsStoreCounter';
import { useTranslation } from 'react-i18next';

const LoginSuccessful = () => {

    const { t } = useTranslation();
    const { user, setShowLoginSuccessful } = useLoginContext();
    const { setWelcomeScreenRead } = useLayoutContext();
    const { cartDisplay } = useCartContext();
    const [timeToReadIcon, setTimeToReadIcon] = useState<boolean>(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeToReadIcon(true);
        }, 4000);

        return () => {
            clearTimeout(timer);
        }
    }, []);

    const handleStart = () => {
        setShowLoginSuccessful(false);
        setWelcomeScreenRead(true);
    }

    return (
        <section className='flex flex-col items-center w-full text-sm w-full'>
            <h4 className='p-6 pb-4 flex flex-col items-center'>
                <span className='mb-1 text-gray-500'>
                    {user 
                        ? <TbMoodHappy size={45} />
                        : <>
                            <TbMoodHappy size={45} className={`transition ${!timeToReadIcon && 'opacity-0 w-0 h-0' }`} />
                            <TbMoodPuzzled size={45} className={`transition ${timeToReadIcon && 'opacity-0 w-0 h-0' }`} />
                        </>
                    }
                </span>
                <span className='font-bold text-2xl text-custom-primary'>
                    {user
                        ? <>{t('login.successful.title', {user: user.first_name})}</>
                        : <>{t('login.successful.title_2')}</>
                    }
                </span>
                <span className='text-lg leading-5'>
                    {cartDisplay
                        ? <>{t('login.successful.cart_display_message', { cartId: formatCartId(cartDisplay?.id) })}</>
                        : <>{t('login.successful.no_cart_message')}</>
                    }
                </span>
                <span className='text-sm text-gray-400 mt-1'>{t('login.successful.help_message')}</span>
            </h4>

            <div className='bg-gray-50 rounded-xl'>
                <StepsStoreCounter />
            </div>

            <div className='flex justify-center p-6'>
                <ButtonPrimary onClick={handleStart} className='justify-center items-center w-full px-6'>
                    {!cartDisplay 
                        ? <>{t('login.successful.button_start_no_cart')}</>
                        : <>{t('login.successful.button_start_with_cart')}</>
                    }
                </ButtonPrimary>
            </div>
        </section>
    );
}

export default LoginSuccessful;
